function sanitizeSnapshotRecord(record) {
  if (!record || typeof record !== 'object') return null;
  if (record.typeName !== 'shape' || record.type !== 'text') return record;
  if (record.props == null || !Object.prototype.hasOwnProperty.call(record.props, 'h')) return record;
  const { h: _removed, ...props } = record.props;
  return { ...record, props };
}

function shouldSkipRecord(record) {
  if (!record || typeof record !== 'object') return true;
  if (record.typeName === 'shape' && record.type === 'pin-card') return true;
  return false;
}

/**
 * Convert tldraw store changes into small board ops suitable for DB persistence.
 */
export function buildBoardDocumentOps(changes) {
  if (!changes || typeof changes !== 'object') return [];
  const ops = [];

  for (const [id, record] of Object.entries(changes.added || {})) {
    if (!id || shouldSkipRecord(record)) continue;
    const sanitized = sanitizeSnapshotRecord(record);
    if (!sanitized) continue;
    ops.push({ kind: 'put', id, record: sanitized });
  }

  for (const [id, tuple] of Object.entries(changes.updated || {})) {
    const next = Array.isArray(tuple) ? tuple[1] : null;
    if (!id || shouldSkipRecord(next)) continue;
    const sanitized = sanitizeSnapshotRecord(next);
    if (!sanitized) continue;
    ops.push({ kind: 'put', id, record: sanitized });
  }

  for (const [id, record] of Object.entries(changes.removed || {})) {
    if (!id) continue;
    // Only drop persisted record ids (pin-card records are not persisted).
    if (shouldSkipRecord(record)) continue;
    ops.push({ kind: 'remove', id });
  }

  return ops;
}
